/* 统一补齐请求头：ngrok 转发头 + API 写请求 CSRF 头 */
(function patchFetchHeaders() {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return
  const nativeFetch = window.fetch.bind(window)
  const isNgrokHost = /ngrok/i.test(window.location.hostname || '')

  const resolveUrl = (input) => {
    if (typeof input === 'string') return input
    if (input && typeof input.url === 'string') return input.url
    return ''
  }

  const isApiWrite = (url, method) => {
    const m = String(method || 'GET').toUpperCase()
    if (!(m === 'POST' || m === 'PUT' || m === 'PATCH' || m === 'DELETE')) return false
    if (!url) return false
    if (url.startsWith('/api/')) return true
    return /^https?:\/\/[^/]+\/api\//i.test(url)
  }

  window.fetch = function (input, init) {
    const next = init ? { ...init } : {}
    const headers = new Headers(next.headers || {})
    const method = next.method || (input && input.method) || 'GET'
    const url = resolveUrl(input)

    if (isNgrokHost && !headers.has('ngrok-skip-browser-warning')) {
      headers.set('ngrok-skip-browser-warning', 'true')
    }
    if (isApiWrite(url, method) && !headers.has('X-CSRF-Token')) {
      headers.set('X-CSRF-Token', 'exam-ui')
    }

    // 同源相对路径 /api/… 与少数场景下的绝对 URL（仍须带会话）
    if (!headers.has('X-Session-Token') && (url.startsWith('/api/') || url.includes('/api/'))) {
      try {
        const u = JSON.parse(localStorage.getItem('exam_user') || '{}')
        if (u && u.sessionToken) headers.set('X-Session-Token', String(u.sessionToken))
      } catch (e) {
        void e
      }
    }

    next.headers = headers
    return nativeFetch(input, next).then(async (res) => {
      if (res.status !== 401 || !url.startsWith('/api/')) return res
      if (url.startsWith('/api/auth/login') || url.startsWith('/api/auth/register')
          || url.startsWith('/api/auth/automan-login') || url.startsWith('/api/auth/automan-sso')
          || url.startsWith('/api/activity/ping')) {
        return res
      }
      let msg = ''
      try {
        const clone = res.clone()
        const j = await clone.json()
        msg = String((j && j.message) || '')
      } catch (e) {
        void e
      }
      if (/会话|未登录|过期|重新登录|身份无效|不一致|其他设备|已下线/i.test(msg)) {
        try {
          localStorage.removeItem('exam_user')
          window.dispatchEvent(new Event('auth-changed'))
          const h = String(window.location.hash || '')
          if (!/#\/(login|ticket-login)/i.test(h)) {
            // 准考证登录页被挤下线时回到对应入口更合理，否则回普通登录
            const lastTicket = String(localStorage.getItem('exam_last_ticket_login_hash') || '').trim()
            if (lastTicket && /#\/ticket-login\//i.test(lastTicket)) {
              window.location.hash = lastTicket
            } else {
              window.location.hash = '#/login'
            }
          }
          if (/其他设备|已下线/i.test(msg)) {
            window.alert(msg)
          }
        } catch (e) {
          void e
        }
      }
      return res
    })
  }
})()

// Best-effort anti-debug guard (can be bypassed by advanced users).
// Only enable in production builds so dev can use F12/DevTools.
void function setupDevtoolsGuard() {
  // Disabled for debugging: this guard can force about:blank and block DevTools.
  const guardEnabled = typeof window !== 'undefined' && window.__ENABLE_DEVTOOLS_GUARD__ === true
  if (!guardEnabled) return
  try {
    if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production') return
  } catch (e) {
    // ignore
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  document.addEventListener('contextmenu', (e) => e.preventDefault())
  document.addEventListener('keydown', (e) => {
    const key = String(e.key || '').toLowerCase()
    if (key === 'f12') {
      e.preventDefault()
      return
    }
    if ((e.ctrlKey && e.shiftKey && (key === 'i' || key === 'j' || key === 'c')) || (e.ctrlKey && key === 'u')) {
      e.preventDefault()
    }
  })

  let suspiciousCount = 0
  const detect = () => {
    // Skip checks while tab is hidden/minimized to avoid false positives.
    if (document.hidden || document.visibilityState !== 'visible') {
      suspiciousCount = 0
      return
    }
    const innerW = window.innerWidth || 0
    const innerH = window.innerHeight || 0
    // Browser minimize/restore may briefly report tiny viewport values.
    if (innerW < 320 || innerH < 240) {
      suspiciousCount = 0
      return
    }
    const widthGap = Math.abs((window.outerWidth || 0) - innerW)
    const heightGap = Math.abs((window.outerHeight || 0) - innerH)
    if (widthGap > 260 || heightGap > 260) {
      suspiciousCount += 1
    } else {
      suspiciousCount = 0
    }
    // Require repeated anomalies before enforcing guard.
    if (suspiciousCount >= 3) {
      try {
        window.location.replace('about:blank')
      } catch (e) {
        void e
      }
    }
  }
  window.setInterval(detect, 1200)
}()

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { formatDateTime } from './utils/datetime'
import { appAlert } from './utils/appDialog'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

const app = createApp(App)
app.config.globalProperties.$fmtDateTime = formatDateTime
app.use(router).mount('#app')

window.alert = (message) => appAlert(String(message))
